(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/tb-ui-react/inline-message/assets/inline-error-message.js') >= 0) return;  svs.modules.push('/components/tb-ui-react/inline-message/assets/inline-error-message.js');
'use strict';

const {
  InlineMessage
} = svs.components.tb_ui_react.inlineMessage;

const InlineErrorMessage = _ref => {
  let {
    actions,
    header,
    className = '',
    children,
    size = '900',
    buttonOptions = {
      inverted: true
    }
  } = _ref;
  return React.createElement(InlineMessage, {
    actions: actions,
    buttonOptions: buttonOptions,
    className: className,
    header: header,
    icon: "exclamation-sign",
    isError: true,
    size: size
  }, children);
};
svs.components.tb_ui_react.inlineMessage.InlineErrorMessage = InlineErrorMessage;

 })(window);